import { createSlice } from '@reduxjs/toolkit';
import { loginAdmin, logoutAdmin } from '../actions/adminActions';

const initialState = {
    admin: null,
    loading: false,
    error: null,
};

const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        clearAdmin: (state) => {
            state.admin = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAdmin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loginAdmin.fulfilled, (state, action) => {
                state.loading = false;
                state.admin = action.payload;
            })
            .addCase(loginAdmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(logoutAdmin.fulfilled, (state) => {
                state.admin = null;
            });
    },
});

export const { clearAdmin } = adminSlice.actions;

export default adminSlice.reducer;